import { resolveCreateInvoiceStatusFromPayment } from "../../../utilis/invoiceStatusHelpers";

/** After approve: awaiting_payment with no payment, else partial/paid. */
export function resolveCommissionApproveInvoiceStatus({
  totalAmount = 0,
  paidAmount = 0,
} = {}) {
  return resolveCreateInvoiceStatusFromPayment({
    requestedStatus: "awaiting_payment",
    totalAmount,
    paidAmount,
  });
}

export function sumCommissionPayloadPaidAmount(payload = {}, payments = []) {
  const list = Array.isArray(payments)
    ? payments
    : Array.isArray(payload?.payments)
      ? payload.payments
      : payload?.payment
        ? [payload.payment]
        : [];

  return list.reduce(
    (sum, row) => sum + Math.max(Number(row?.amount) || 0, 0),
    0,
  );
}

export function applyCommissionApproveFields(
  requestBody,
  { totalAmount = 0, paidAmount = 0 } = {},
) {
  const status = resolveCommissionApproveInvoiceStatus({
    totalAmount,
    paidAmount,
  });
  return {
    ...requestBody,
    approved: true,
    status,
  };
}
